(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["cc-colour-swatches"] && !Shopify.designMode) return;
  try {
    (function() {
    function hideNativeColourFieldset() {
      var pickers = document.querySelectorAll('variant-picker, .variant-picker, [class*="variant-picker"]');
      pickers.forEach(function(picker) {
        var fieldsets = picker.querySelectorAll('fieldset');
        fieldsets.forEach(function(fs) {
          var legend = fs.querySelector('legend');
          if (!legend) return;
          var text = (legend.textContent || '').trim().toLowerCase();
          if (text === 'colour' || text === 'color' || text.indexOf('colour') === 0 || text.indexOf('color') === 0) {
            fs.style.display = 'none';
            fs.classList.add('cc-hide-colour');
          }
        });
      });
    }

    function init(scope) {
      var root = scope || document;
      var pickers = root.querySelectorAll('.cc-colour-swatches');
      pickers.forEach(function(picker) {
        if (picker.dataset.ccBound === '1') return;
        picker.dataset.ccBound = '1';
        var selectedLabel = picker.querySelector('[data-cc-selected-colour]');
        var swatches = picker.querySelectorAll('.cc-swatch');
        swatches.forEach(function(btn) {
          var handler = function(e) {
            e.preventDefault();
            var colour = btn.getAttribute('data-cc-colour');
            var variantUrl = btn.getAttribute('data-cc-variant-url');
            swatches.forEach(function(b) {
              b.classList.remove('cc-swatch--selected');
              b.setAttribute('aria-checked', 'false');
            });
            btn.classList.add('cc-swatch--selected');
            btn.setAttribute('aria-checked', 'true');
            if (selectedLabel) selectedLabel.textContent = colour;
            var nativeColourInput = null;
            var nativeInputs = document.querySelectorAll('input[type="radio"]');
            nativeInputs.forEach(function(input) {
              if (input.value === colour) {
                var fs = input.closest('fieldset');
                if (fs) {
                  var legend = fs.querySelector('legend');
                  if (legend) {
                    var legendText = (legend.textContent || '').toLowerCase();
                    if (legendText.indexOf('colour') !== -1 || legendText.indexOf('color') !== -1) {
                      nativeColourInput = input;
                    }
                  }
                }
              }
            });
            if (nativeColourInput) {
              nativeColourInput.checked = true;
              nativeColourInput.dispatchEvent(new Event('change', { bubbles: true }));
            } else if (variantUrl) {
              window.location.href = variantUrl;
            }
          };
          btn.addEventListener('click', handler);
          btn.addEventListener('keydown', function(e) {
            if (e.key === 'Enter' || e.key === ' ') {
              handler(e);
            }
          });
        });
      });
      hideNativeColourFieldset();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function() { init(); });
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', function(e) { init(e.target); });
    setTimeout(hideNativeColourFieldset, 100);
    setTimeout(hideNativeColourFieldset, 500);
    setTimeout(hideNativeColourFieldset, 1500);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["cc-gallery-filter"] && !Shopify.designMode) return;
  try {
    /*
   * cc-gallery-filter
   *
   * One debounced filter pass. ONE.
   *
   * Why: Horizon rebuilds the gallery DOM on variant change. Earlier versions of this
   * block fired applyFilter multiple times per click via bare setTimeouts that bypassed
   * the debouncer — first 3 passes saw a half-built DOM and produced wrong counts,
   * fourth pass saw the settled DOM and produced the correct one. User saw a visible
   * reshuffle. Fix: every signal funnels through a single debounced scheduler, anchored
   * to MutationObserver (which only fires once Horizon has actually mutated the DOM).
   */
  (function() {
    if (window.__ccGalleryFilterInit) return;
    window.__ccGalleryFilterInit = true;

    var IDLE_MS = 180; // wait this long after the last DOM mutation before filtering
    var _timer = null;
    var _busyTimer = null;

    function readMap() {
      var script = document.querySelector('[data-cc-variant-media-map]');
      if (!script) return {};
      try {
        var arr = JSON.parse(script.textContent);
        var map = {};
        arr.forEach(function(entry) {
          if (entry && entry.colour && entry.mediaId && !map[entry.colour]) {
            map[entry.colour] = String(entry.mediaId);
          }
        });
        return map;
      } catch (e) {
        console.warn('[cc-gallery-filter] map parse failed', e);
        return {};
      }
    }

    function selectedColour() {
      var sel = document.querySelector('.cc-colour-swatches .cc-swatch--selected');
      if (sel) {
        var c = sel.getAttribute('data-cc-colour');
        if (c) return c;
      }
      var radios = document.querySelectorAll('input[type="radio"]:checked');
      for (var i = 0; i < radios.length; i++) {
        var r = radios[i];
        var fs = r.closest('fieldset');
        if (!fs) continue;
        var legend = fs.querySelector('legend');
        if (!legend) continue;
        var lt = (legend.textContent || '').toLowerCase();
        if (lt.indexOf('colour') !== -1 || lt.indexOf('color') !== -1) {
          return r.value;
        }
      }
      return null;
    }

    function getWrapper(mediaEl) {
      return (
        mediaEl.closest('.product-media-container') ||
        mediaEl.closest('slideshow-slide') ||
        mediaEl.closest('[ref="media[]"]') ||
        mediaEl.closest('li') ||
        mediaEl
      );
    }

    function applyFilter() {
      var colour = selectedColour();
      if (!colour) return;
      var colourLower = colour.toLowerCase();
      var map = readMap();
      var boundMediaId = map[colour] || null;

      document.querySelectorAll('media-gallery').forEach(function(gallery) {
        var medias = gallery.querySelectorAll('.product-media[data-media-id]');
        var visibleCount = 0;

        medias.forEach(function(mediaEl) {
          var mediaId = mediaEl.getAttribute('data-media-id');
          var img = mediaEl.querySelector('img');
          var alt = img && img.alt ? img.alt.toLowerCase() : '';
          var isBound = boundMediaId && mediaId === boundMediaId;
          var altMatches = colourLower && alt.indexOf(colourLower) !== -1;
          var show = isBound || altMatches;
          var wrapper = getWrapper(mediaEl);
          if (show) {
            wrapper.removeAttribute('data-cc-filter-hidden');
            visibleCount++;
          } else {
            wrapper.setAttribute('data-cc-filter-hidden', 'true');
          }
        });

        if (visibleCount === 0) {
          var first = gallery.querySelector('.product-media[data-media-id]');
          if (first) getWrapper(first).removeAttribute('data-cc-filter-hidden');
        }

        gallery.setAttribute('data-cc-active-colour', colour);
        gallery.removeAttribute('data-cc-filter-busy');
      });
    }

    function scheduleFilter() {
      // Mark gallery as busy so CSS suppresses transitions during the settle window
      document.querySelectorAll('media-gallery').forEach(function(g) {
        g.setAttribute('data-cc-filter-busy', 'true');
      });
      clearTimeout(_busyTimer);
      _busyTimer = setTimeout(function() {
        document.querySelectorAll('media-gallery').forEach(function(g) {
          g.removeAttribute('data-cc-filter-busy');
        });
      }, IDLE_MS + 300);

      clearTimeout(_timer);
      _timer = setTimeout(applyFilter, IDLE_MS);
    }

    function bindEvents() {
      // PRIMARY signal: MutationObserver fires when Horizon mutates the gallery DOM.
      // Debounce means we only run once after the burst of mutations finishes.
      document.querySelectorAll('media-gallery').forEach(function(gallery) {
        try {
          var obs = new MutationObserver(scheduleFilter);
          obs.observe(gallery, { childList: true, subtree: true });
        } catch (e) {}
      });

      // Cheap insurance: if a swatch is clicked but no DOM mutation follows
      // (e.g. selecting the already-active colour), still re-evaluate.
      document.addEventListener('click', function(e) {
        if (e.target && e.target.closest && e.target.closest('.cc-swatch')) {
          scheduleFilter();
        }
      }, true);

      // Section reload fallback (e.g. theme editor reload)
      document.addEventListener('shopify:section:load', scheduleFilter);
    }

    function init() {
      // Initial pass — DOM is already rendered server-side with hide_variants logic
      applyFilter();
      bindEvents();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["cc-instagram-carousel"] && !Shopify.designMode) return;
  try {
    (function() {
    function init(scope) {
      var carousels = (scope || document).querySelectorAll('[data-cc-ig-carousel]');
      carousels.forEach(function(carousel) {
        if (carousel.dataset.ccIgBound === '1') return;
        carousel.dataset.ccIgBound = '1';
        var wrap = carousel.closest('.cc-instagram__carousel-wrap');
        if (!wrap) return;
        var prevBtn = wrap.querySelector('[data-cc-ig-prev]');
        var nextBtn = wrap.querySelector('[data-cc-ig-next]');
        function getStep() {
          var firstItem = carousel.querySelector('.cc-instagram__item');
          if (!firstItem) return carousel.clientWidth * 0.8;
          var style = window.getComputedStyle(carousel);
          var gap = parseInt(style.columnGap || style.gap, 10) || 0;
          return firstItem.offsetWidth + gap;
        }
        function updateNavState() {
          var atStart = carousel.scrollLeft <= 2;
          var atEnd = (carousel.scrollLeft + carousel.clientWidth) >= (carousel.scrollWidth - 2);
          if (prevBtn) prevBtn.dataset.ccIgDisabled = atStart ? 'true' : 'false';
          if (nextBtn) nextBtn.dataset.ccIgDisabled = atEnd ? 'true' : 'false';
        }
        if (prevBtn) { prevBtn.addEventListener('click', function() { carousel.scrollBy({ left: -getStep(), behavior: 'smooth' }); }); }
        if (nextBtn) { nextBtn.addEventListener('click', function() { carousel.scrollBy({ left: getStep(), behavior: 'smooth' }); }); }
        carousel.addEventListener('scroll', updateNavState, { passive: true });
        window.addEventListener('resize', updateNavState);
        updateNavState();
      });
    }
    if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', function() { init(); }); } else { init(); }
    document.addEventListener('shopify:section:load', function(e) { init(e.target); });
  })();
  } catch(e) { console.error(e); }
})();

})();
